import React from "react";

// Unique geometric logo mark for Mirexiluna: stacked "M/L" building silhouette with a moon accent.
export default function Logo({ className = "h-8 w-auto", withText = true }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} aria-label="Mirexiluna">
      <svg
        viewBox="0 0 44 44"
        xmlns="http://www.w3.org/2000/svg"
        className="h-8 w-8 flex-shrink-0"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="mx-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#0F1B2D" />
            <stop offset="1" stopColor="#2A4A7F" />
          </linearGradient>
        </defs>
        <rect x="1.5" y="1.5" width="41" height="41" rx="10" fill="url(#mx-grad)" />
        {/* stacked buildings */}
        <rect x="9" y="20" width="6" height="16" fill="#EDE7DA" />
        <rect x="17" y="13" width="6" height="23" fill="#EDE7DA" />
        <rect x="25" y="17" width="6" height="19" fill="#EDE7DA" />
        {/* windows accent */}
        <rect x="19" y="17" width="2" height="2" fill="#0F1B2D" />
        <rect x="19" y="22" width="2" height="2" fill="#0F1B2D" />
        <rect x="27" y="21" width="2" height="2" fill="#0F1B2D" />
        {/* moon */}
        <circle cx="33" cy="11" r="3.5" fill="#E9B949" />
        <circle cx="31.4" cy="10.4" r="3.5" fill="url(#mx-grad)" />
      </svg>
      {withText && (
        <span className="font-semibold tracking-tight text-[15px] leading-none text-[#0F1B2D]">
          mirexi<span className="text-[#B3862B]">luna</span>
        </span>
      )}
    </span>
  );
}
